<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Autoplay } from "swiper/modules";

// CSS ضروري
import "swiper/css";
import "swiper/css/pagination";
</script>

<template>
  <div class="col-xl-4" v-if="streams.length">
    <div class="card card-xl-stretch mb-5 mb-xl-8">
      <!-- Header -->
      <div class="card-header align-items-center border-0 mt-3">
        <h3 class="card-title align-items-start flex-column">
          <span class="fw-bold text-dark fs-3">
            <i
              class="fas fa-broadcast-tower"
              style="
                border-radius: 10px;
                padding: 8px 10px;
                background: #98fd8b6c;
                color: #56c600ff;
              "
            ></i>
            بثوث قد تعجبك
          </span>
          <span class="text-gray-400 mt-2 fw-semibold fs-6">
            تصفح هنا البثوث التي قد تعجبك
          </span>
        </h3>
      </div>

      <!-- Body -->
      <div class="card-body pt-5">
        <div v-if="isLoadingStreams" class="text-center mt-3">
          <span class="spinner-border spinner-border-lg text-success"></span>
          <p>جاري تحميل البثوث...</p>
        </div>

        <div v-else>
          <Swiper
            :modules="[Pagination, Autoplay]"
            :slides-per-view="1"
            :space-between="10"
            :pagination="{ clickable: true }"
            :autoplay="{ delay: 2500, disableOnInteraction: false }"
            loop
            class="mySwiper"
          >
            <SwiperSlide v-for="stream in streams" :key="stream.class_id">
              <div class="d-flex mb-7">
                <div class="d-flex flex-column flex-grow-1 pe-3">
                  <a
                    href="javascript:void(0)"
                    class="fs-5 text-gray-800 text-hover-primary fw-bold"
                  >
                    {{ stream.title }}
                  </a>
                  <span class="text-gray-400 fw-semibold fs-7">
                    <div v-if="isLive(stream)">
                      <b class="badge badge-dark p-2">مباشر الآن</b>
                      <br />
                      <span class="badge badge-secondary text-dark m-1">
                        ينتهي في {{ stream.live_ends_at }}
                      </span>
                      <br />
                      <button
                        class="btn btn-light text-success btn-sm mt-2"
                        @click="joinLiveStream($event, stream.class_id)"
                      >
                        إنضمام
                      </button>
                    </div>

                    <div v-else-if="isEnded(stream)">
                      <b class="badge badge-danger">انتهى البث</b>
                    </div>

                    <div v-else>
                      <b class="badge badge-success">
                        يبدأ في {{ stream.live_starts_at }}
                      </b>
                      <br />
                      <button
                        class="btn btn-light text-success btn-sm mt-2"
                        @click="joinLiveStream($event, stream.class_id)"
                      >
                        إنضمام
                      </button>
                    </div>
                  </span>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUrl } from "@/utils/api";

export default {
  name: "DashboardView",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      streams: [],
      isLoadingStreams: false,
    };
  },
  mounted() {
    this.getsuggestLive();
  },
  methods: {
    async getsuggestLive() {
      this.isLoadingStreams = true;
      try {
        const response = await fetch(`${apiUrl}/livestream/get-similar-courses`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          this.streams = await response.json();
        } else {
          console.error("Failed to fetch live streams");
        }
      } catch (error) {
        console.error("Error fetching live streams:", error);
      } finally {
        this.isLoadingStreams = false;
      }
    },

    async joinLiveStream(event, id) {
      let button = event.target;

      let originalContent = button.innerHTML;

      button.innerHTML = `<span class="spinner-border spinner-border-sm"></span> جاري الانضمام...`;
      button.classList.add("disabled");
      try {
        const response = await fetch(`${apiUrl}/livestream/token/` + id, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        });

        let data = await response.json();

        if (data.token) {
          window.open(`https://live.academia.ly/?token=${data.token}`, "_blank");
        } else {
          alert("فشل في جلب التوكن، حاول مرة أخرى!");
        }
      } catch (error) {
        console.error("Error fetching token:", error);
        alert("حدث خطأ أثناء الاتصال بالخادم!");
      } finally {
        // إعادة محتوى الزر إلى حالته الأصلية
        button.innerHTML = originalContent;
        button.classList.remove("disabled");
      }
    },
    isLive(stream) {
      const now = new Date();
      return (
        new Date(stream.live_starts_at) <= now && new Date(stream.live_ends_at) >= now
      );
    },
    isEnded(stream) {
      return new Date(stream.live_ends_at) < new Date();
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleString("ar-EG", { dateStyle: "full", timeStyle: "short" });
    },
  },
};
</script>

<style scoped>
.card {
  border-radius: 10px;
}

.card-body {
  text-align: right;
}
</style>
